import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import AssetCard from '../components/AssetCard';
import api from '../api/ApiClient';

export default function SellerProfile() {
  const { id } = useParams();
  const [seller, setSeller] = useState(null);
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.listAssets({ status: 'published', limit: 50 }).then(d => {
      const filtered = (d.assets || []).filter(a => String(a.ownerId?._id || a.ownerId) === id);
      setAssets(filtered);
      if (filtered.length) setSeller(filtered[0].ownerId);
    }).finally(() => setLoading(false));
  }, [id]);

  const ss = seller?.sellerStats || {};

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <header style={{
        position: 'sticky', top: 0, zIndex: 50, background: 'rgba(255,255,255,0.92)',
        backdropFilter: 'blur(8px)', borderBottom: '1px solid var(--border)',
        padding: '0 24px', height: 52, display: 'flex', alignItems: 'center', gap: 12,
      }}>
        <Link to="/" style={{ fontWeight: 700, fontSize: 17, color: 'var(--text)', textDecoration: 'none', letterSpacing: '-0.3px' }}>dApiary</Link>
      </header>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '32px 24px' }}>
        {loading ? (
          <div style={{ color: 'var(--text-3)' }}>Loading…</div>
        ) : (
          <>
            {/* Seller card */}
            <div className="card" style={{ padding: 28, marginBottom: 28, display: 'flex', alignItems: 'center', gap: 20 }}>
              <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'var(--accent-bg)', color: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 700, flexShrink: 0, overflow: 'hidden', border: '2px solid var(--border)' }}>
                {seller?.avatar
                  ? <img src={seller.avatar} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  : (seller?.name || 'U')[0]
                }
              </div>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                  <h1 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', margin: 0 }}>{seller?.name || 'Seller'}</h1>
                  {ss.isVerifiedSeller && (
                    <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 4, fontWeight: 700, background: '#F0FDF4', color: '#16A34A', border: '1px solid #BBF7D0' }}>
                      Verified Seller
                    </span>
                  )}
                </div>
                <div style={{ display: 'flex', gap: 20, fontSize: 13, color: 'var(--text-2)', flexWrap: 'wrap' }}>
                  <span>{(ss.rating || 0).toFixed(1)} avg rating</span>
                  <span>{assets.length} assets</span>
                  <span>{ss.totalSales || 0} sales</span>
                  <span>{ss.reviewCount || 0} reviews</span>
                </div>
              </div>
            </div>

            {/* Assets grid */}
            <h2 style={{ fontSize: 15, fontWeight: 600, color: 'var(--text)', marginBottom: 16 }}>Published Assets</h2>
            {assets.length === 0 ? (
              <div className="card" style={{ padding: '40px 24px', textAlign: 'center', color: 'var(--text-2)' }}>
                No published assets.
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 14, alignItems: 'stretch' }}>
                {assets.map(a => <AssetCard key={a._id} asset={a} />)}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
